import gql from 'graphql-tag';

export const createAdyenAccount = gql`
	mutation CreateAdyenAccount($input: AdyenAccountInput) {
		createAdyenAccount(input: $input) {
			merchantId
			storeId
			storeReference
		}
	}
`;

export const getAdyenAccount = gql`
	query GetAdyenAccount {
		getAdyenAccount {
			merchantId
			storeId
			storeReference
		}
	}
`;

export const deleteAdyenAccount = gql`
	mutation deleteAdyenAccount {
		deleteAdyenAccount
	}
`;

// Query used to retrieve list of adyen terminals
export const listAdyenTerminals = gql`
	query adyenTerminals {
		adyenTerminals {
			terminalId
			terminalName
		}
	}
`;

export const GET_MERCHANT_LIST = gql`
	query GetMerchantList {
		getMerchantList {
			label
			value
		}
	}
`;

// Mutation used to update a adyen Terminal
export const updateAdyenTerminal = gql`
	mutation updateAdyenTerminal($input: AdyenTerminalInput) {
		updateAdyenTerminal(input: $input) {
			terminalId
			terminalName
		}
	}
`;

export const getTimeZone = gql`
	query GetTimeZone {
		getTimeZone {
			timezone
		}
	}
`;

export default {
	createAdyenAccount,
	getAdyenAccount,
	deleteAdyenAccount,
	listAdyenTerminals,
	updateAdyenTerminal,
};
